import { Skeleton } from '@pets-ui/Skeleton/Skeleton'
import { useResponsive } from '@pets-ui/useResponsive/useResponsive'
import { VStack } from '@pets-ui/VStack/VStack'

export function SkeletonOrderDetail() {
  const isMobile = useResponsive('mobile')
  return (
    <VStack gap={4} alignItems="flex-end" width="100%">
      <Skeleton variant="rounded" height={172} width="100%" />
      <Skeleton variant="rounded" height={340} width="100%" />
      <Skeleton variant="rounded" height={392} width={isMobile ? '100%' : '400px'} />
      <Skeleton variant="rounded" height={72} width={isMobile ? '100%' : '400px'} />
    </VStack>
  )
}
